import React from "react";
import { JhButton } from "designPackages/buttonPackage";
import CreditService from "../../services/CreditService";
import { useRouter } from "next/router";
import { Routes } from "../../routes/RouteConstants";
import useCheckSufficientCredits from "../../hooks/checkSufficientCredits";
import CookieService from "services/CookieService";

type RenderView = (
  onClick: (event: React.MouseEvent<HTMLElement>) => void
) => JSX.Element;

interface UpgradeToPremiumViewProps {
  children: React.ReactNode;
  renderView?: RenderView;
  jobId: number;
  callback?: (isSufficientCredits: boolean | null, response?: object) => void;
  className?: string;
}

const UpgradeToPremiumView = ({
  children,
  renderView,
  callback,
  jobId,
  className = ""
}: UpgradeToPremiumViewProps) => {
  const router = useRouter();
  const isSufficientCredits = useCheckSufficientCredits({
    jobId
  });
  const onUpgrade = async (e: React.MouseEvent<HTMLElement>) => {
    if (!isSufficientCredits) {
      const isNativeApp = CookieService.getCookie("is_native_app");

      if (isNativeApp) {
        window.open(`/hire${Routes.PLAN_SELECTION}`, "_blank");
        return;
      }

      router.push(`${Routes.CHECKOUT}?flow=upgrade&jobId=${jobId}`).then(() => {
        if (callback) callback(isSufficientCredits);
      });
    } else {
      const response = await CreditService.upgradeJob({ jobId });
      if (callback) callback(isSufficientCredits, response);
    }
  };

  if (renderView) {
    return renderView(onUpgrade);
  }

  return (
    <JhButton className={className} onClick={onUpgrade}>
      {children}
    </JhButton>
  );
};
export default UpgradeToPremiumView;
